export default __webpack_public_path__ + "static/media/lluviasoleado.8f1074af.gif";